import React, { useMemo } from 'react';

export default function Wishlist() {
  // Placeholder static data; can later connect to localStorage or backend
  const items = useMemo(() => ([
    { name: 'Charizard ex', set: 'Pokemon 151', price: 89.99, trend: +5.2 },
    { name: 'Mew ex', set: 'Pokemon 151', price: 67.25, trend: -2.1 },
    { name: 'Pikachu VMAX', set: 'Vivid Voltage', price: 45.5, trend: -8.3 },
    { name: 'Umbreon VMAX', set: 'Evolving Skies', price: 156.8, trend: +12.7 },
  ]), []);

  return (
    <div className="p-6 text-white">
      <h1 className="text-3xl font-bold mb-6">My Wishlist</h1>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {items.map((it) => (
          <div key={it.name} className="bg-black/40 rounded-lg p-4">
            <div className="h-40 bg-white/10 rounded mb-3" />
            <div className="font-semibold">{it.name}</div>
            <div className="text-xs opacity-70 mb-2">{it.set}</div>
            <div className={`font-mono ${it.trend >= 0 ? 'text-green-300' : 'text-red-300'}`}>
              ${it.price} {it.trend >= 0 ? '↗' : '↘'} {Math.abs(it.trend)}%
            </div>
            <div className="mt-3 flex gap-2">
              <button className="bg-white/20 hover:bg-white/30 text-white text-sm px-3 py-1 rounded">View Market</button>
              <button className="bg-blue-600 hover:bg-blue-500 text-white text-sm px-3 py-1 rounded">Set Alert</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


